import AgencyApi from '@/api/agency'
import { AgencyModel } from '@/models/Agency'

const assignModel = data => {
  return data.map(o => new AgencyModel(o))
}

const actions = {
  async SEARCH_AGENCY(
    { commit },
    {
      keyword,
      agencyStatuses,
      minPermissionLevel,
      pageNo,
      pageSize,
      sortKey,
      sortDirection,
    },
  ) {
    commit('SET_LOADING', 'searchResult')
    const params = {
      keyword,
      agencyStatuses,
      minPermissionLevel,
      pageNo,
      pageSize,
      sortKey,
      sortDirection,
    }
    let ret = await AgencyModel.searchAgency(params)
    // const { items } = ret
    ret['pageSize'] = pageSize
    commit('SET_AGENCY_SEARCH_RESULT', ret)
    commit('CLEAR_LOADING', 'searchResult')
  },
  async GET_AGENCY_LIST({ commit, dispatch }, { minPermissionLevel }) {
    const listData = await dispatch('fetchListData', minPermissionLevel)
    const { items } = listData
    const modeledItems = assignModel(items)
    commit('SET_AGENCY_LIST', modeledItems)
  },
  fetchListData(_, minPermissionLevel) {
    return AgencyApi.searchAgency({ minPermissionLevel })
  },
  /* eslint-disable no-unused-vars */
  async ADD_AGENCY({ dispatch }, { item }) {
    await AgencyApi.addAgency(item)
  },
  /* eslint-disable no-unused-vars */
  async EDIT_AGENCY({ dispatch }, { id, body }) {
    try {
      await AgencyApi.editAgency(id, body)
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  /* eslint-disable no-unused-vars */
  async DELETE_AGENCY({ dispatch }, { id }) {
    try {
      await AgencyApi.deleteAgency(id)
    } catch (e) {
      console.log(e)
      throw e
    }
  },
}

export default actions
